// This file is auto-generated by @hey-api/openapi-ts
// @ts-nocheck

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { deleteApiServicesAssistantcollectionsById, deleteApiServicesAssistantcollectionsByIdAssistantsByAssistantId, deleteApiServicesAssistantcollectionsByIdFollow, deleteApiServicesAssistantkindsById, deleteApiServicesAssistantsById, getApiAuthCapabilities, getApiAuthToken, getApiServicesAssistantcollections, getApiServicesAssistantcollectionsById, getApiServicesAssistantcollectionsByIdAssistants, getApiServicesAssistantkinds, getApiServicesAssistantkindsById, getApiServicesAssistants, getApiServicesAssistantsById, getApiServicesChatSessions, getApiServicesChatSessionsById, type Options, patchApiServicesAssistantcollectionsById, patchApiServicesAssistantkindsById, patchApiServicesAssistantsById, patchApiServicesChatSessionsById, postApiServicesAssistantcollections, postApiServicesAssistantcollectionsByIdAssistants, postApiServicesAssistantcollectionsByIdFollow, postApiServicesAssistantkinds, postApiServicesAssistants, postApiServicesAssistantsByIdPublish, postApiServicesAssistantsByIdUnpublish, postApiServicesChatSessions, postApiServicesChatSessionsByIdArchive, postApiServicesChatSessionsByIdUnarchive } from '../sdk.gen';
import type { DeleteApiServicesAssistantcollectionsByIdAssistantsByAssistantIdData, DeleteApiServicesAssistantcollectionsByIdAssistantsByAssistantIdError, DeleteApiServicesAssistantcollectionsByIdAssistantsByAssistantIdResponse, DeleteApiServicesAssistantcollectionsByIdData, DeleteApiServicesAssistantcollectionsByIdError, DeleteApiServicesAssistantcollectionsByIdFollowData, DeleteApiServicesAssistantcollectionsByIdFollowError, DeleteApiServicesAssistantcollectionsByIdFollowResponse, DeleteApiServicesAssistantcollectionsByIdResponse, DeleteApiServicesAssistantkindsByIdData, DeleteApiServicesAssistantkindsByIdError, DeleteApiServicesAssistantkindsByIdResponse, DeleteApiServicesAssistantsByIdData, DeleteApiServicesAssistantsByIdError, DeleteApiServicesAssistantsByIdResponse, GetApiAuthCapabilitiesData, GetApiAuthCapabilitiesResponse, GetApiAuthTokenData, GetApiAuthTokenError, GetApiAuthTokenResponse, GetApiServicesAssistantcollectionsByIdAssistantsData, GetApiServicesAssistantcollectionsByIdAssistantsError, GetApiServicesAssistantcollectionsByIdAssistantsResponse, GetApiServicesAssistantcollectionsByIdData, GetApiServicesAssistantcollectionsByIdError, GetApiServicesAssistantcollectionsByIdResponse, GetApiServicesAssistantcollectionsData, GetApiServicesAssistantcollectionsError, GetApiServicesAssistantcollectionsResponse, GetApiServicesAssistantkindsByIdData, GetApiServicesAssistantkindsByIdError, GetApiServicesAssistantkindsByIdResponse, GetApiServicesAssistantkindsData, GetApiServicesAssistantkindsResponse, GetApiServicesAssistantsByIdData, GetApiServicesAssistantsByIdError, GetApiServicesAssistantsByIdResponse, GetApiServicesAssistantsData, GetApiServicesAssistantsError, GetApiServicesAssistantsResponse, GetApiServicesChatSessionsByIdData, GetApiServicesChatSessionsByIdError, GetApiServicesChatSessionsByIdResponse, GetApiServicesChatSessionsData, GetApiServicesChatSessionsError, GetApiServicesChatSessionsResponse, PatchApiServicesAssistantcollectionsByIdData, PatchApiServicesAssistantcollectionsByIdError, PatchApiServicesAssistantcollectionsByIdResponse, PatchApiServicesAssistantkindsByIdData, PatchApiServicesAssistantkindsByIdError, PatchApiServicesAssistantkindsByIdResponse, PatchApiServicesAssistantsByIdData, PatchApiServicesAssistantsByIdError, PatchApiServicesAssistantsByIdResponse, PatchApiServicesChatSessionsByIdData, PatchApiServicesChatSessionsByIdError, PatchApiServicesChatSessionsByIdResponse, PostApiServicesAssistantcollectionsByIdAssistantsData, PostApiServicesAssistantcollectionsByIdAssistantsError, PostApiServicesAssistantcollectionsByIdAssistantsResponse, PostApiServicesAssistantcollectionsByIdFollowData, PostApiServicesAssistantcollectionsByIdFollowError, PostApiServicesAssistantcollectionsByIdFollowResponse, PostApiServicesAssistantcollectionsData, PostApiServicesAssistantcollectionsError, PostApiServicesAssistantcollectionsResponse, PostApiServicesAssistantkindsData, PostApiServicesAssistantkindsError, PostApiServicesAssistantkindsResponse, PostApiServicesAssistantsByIdPublishData, PostApiServicesAssistantsByIdPublishError, PostApiServicesAssistantsByIdPublishResponse, PostApiServicesAssistantsByIdUnpublishData, PostApiServicesAssistantsByIdUnpublishError, PostApiServicesAssistantsByIdUnpublishResponse, PostApiServicesAssistantsData, PostApiServicesAssistantsError, PostApiServicesAssistantsResponse, PostApiServicesChatSessionsByIdArchiveData, PostApiServicesChatSessionsByIdArchiveError, PostApiServicesChatSessionsByIdArchiveResponse, PostApiServicesChatSessionsByIdUnarchiveData, PostApiServicesChatSessionsByIdUnarchiveError, PostApiServicesChatSessionsByIdUnarchiveResponse, PostApiServicesChatSessionsData, PostApiServicesChatSessionsError, PostApiServicesChatSessionsResponse } from '../types.gen';

/**
 * Delete assistant and all its versions
 */
export const deleteApiServicesAssistantsByIdMutation = (options?: Partial<Options<DeleteApiServicesAssistantsByIdData>>): UseMutationOptions<DeleteApiServicesAssistantsByIdResponse, DeleteApiServicesAssistantsByIdError, Options<DeleteApiServicesAssistantsByIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiServicesAssistantsByIdResponse, DeleteApiServicesAssistantsByIdError, Options<DeleteApiServicesAssistantsByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiServicesAssistantsById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const getApiServicesAssistantsByIdQueryKey = (options: Options<GetApiServicesAssistantsByIdData>) => createQueryKey('getApiServicesAssistantsById', options, false, ['assistants']);

/**
 * Get assistant by ID with latest version data
 */
export const getApiServicesAssistantsByIdOptions = (options: Options<GetApiServicesAssistantsByIdData>) => queryOptions<GetApiServicesAssistantsByIdResponse, GetApiServicesAssistantsByIdError, GetApiServicesAssistantsByIdResponse, ReturnType<typeof getApiServicesAssistantsByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiServicesAssistantsById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiServicesAssistantsByIdQueryKey(options)
});

/**
 * Update assistant (creates new version if systemPrompt or notes change)
 */
export const patchApiServicesAssistantsByIdMutation = (options?: Partial<Options<PatchApiServicesAssistantsByIdData>>): UseMutationOptions<PatchApiServicesAssistantsByIdResponse, PatchApiServicesAssistantsByIdError, Options<PatchApiServicesAssistantsByIdData>> => {
    const mutationOptions: UseMutationOptions<PatchApiServicesAssistantsByIdResponse, PatchApiServicesAssistantsByIdError, Options<PatchApiServicesAssistantsByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchApiServicesAssistantsById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiServicesAssistantsQueryKey = (options?: Options<GetApiServicesAssistantsData>) => createQueryKey('getApiServicesAssistants', options, false, ['assistants']);

/**
 * List assistants with pagination and optional visibility filter
 */
export const getApiServicesAssistantsOptions = (options?: Options<GetApiServicesAssistantsData>) => queryOptions<GetApiServicesAssistantsResponse, GetApiServicesAssistantsError, GetApiServicesAssistantsResponse, ReturnType<typeof getApiServicesAssistantsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiServicesAssistants({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiServicesAssistantsQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const getApiServicesAssistantsInfiniteQueryKey = (options?: Options<GetApiServicesAssistantsData>): QueryKey<Options<GetApiServicesAssistantsData>> => createQueryKey('getApiServicesAssistants', options, true);

/**
 * List assistants with pagination and optional visibility filter
 */
export const getApiServicesAssistantsInfiniteOptions = (options?: Options<GetApiServicesAssistantsData>) => infiniteQueryOptions<GetApiServicesAssistantsResponse, GetApiServicesAssistantsError, InfiniteData<GetApiServicesAssistantsResponse>, QueryKey<Options<GetApiServicesAssistantsData>>, number | Pick<QueryKey<Options<GetApiServicesAssistantsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiServicesAssistantsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getApiServicesAssistants({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiServicesAssistantsInfiniteQueryKey(options)
});

/**
 * Create assistant with initial version
 */
export const postApiServicesAssistantsMutation = (options?: Partial<Options<PostApiServicesAssistantsData>>): UseMutationOptions<PostApiServicesAssistantsResponse, PostApiServicesAssistantsError, Options<PostApiServicesAssistantsData>> => {
    const mutationOptions: UseMutationOptions<PostApiServicesAssistantsResponse, PostApiServicesAssistantsError, Options<PostApiServicesAssistantsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiServicesAssistants({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Publish an assistant (admin only)
 */
export const postApiServicesAssistantsByIdPublishMutation = (options?: Partial<Options<PostApiServicesAssistantsByIdPublishData>>): UseMutationOptions<PostApiServicesAssistantsByIdPublishResponse, PostApiServicesAssistantsByIdPublishError, Options<PostApiServicesAssistantsByIdPublishData>> => {
    const mutationOptions: UseMutationOptions<PostApiServicesAssistantsByIdPublishResponse, PostApiServicesAssistantsByIdPublishError, Options<PostApiServicesAssistantsByIdPublishData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiServicesAssistantsByIdPublish({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unpublish an assistant (admin only)
 */
export const postApiServicesAssistantsByIdUnpublishMutation = (options?: Partial<Options<PostApiServicesAssistantsByIdUnpublishData>>): UseMutationOptions<PostApiServicesAssistantsByIdUnpublishResponse, PostApiServicesAssistantsByIdUnpublishError, Options<PostApiServicesAssistantsByIdUnpublishData>> => {
    const mutationOptions: UseMutationOptions<PostApiServicesAssistantsByIdUnpublishResponse, PostApiServicesAssistantsByIdUnpublishError, Options<PostApiServicesAssistantsByIdUnpublishData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiServicesAssistantsByIdUnpublish({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiAuthTokenQueryKey = (options?: Options<GetApiAuthTokenData>) => createQueryKey('getApiAuthToken', options, false, ['auth']);

/**
 * Get authentication token
 *
 * Returns the raw JWT token from the authenticated user's session. Useful for frontends that need access to the token stored in an HttpOnly cookie.
 */
export const getApiAuthTokenOptions = (options?: Options<GetApiAuthTokenData>) => queryOptions<GetApiAuthTokenResponse, GetApiAuthTokenError, GetApiAuthTokenResponse, ReturnType<typeof getApiAuthTokenQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiAuthToken({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiAuthTokenQueryKey(options)
});

export const getApiAuthCapabilitiesQueryKey = (options?: Options<GetApiAuthCapabilitiesData>) => createQueryKey('getApiAuthCapabilities', options, false, ['auth']);

/**
 * Get user capabilities for page-level access control
 *
 * Returns boolean flags indicating what high-level actions the current user can perform. Used by the frontend to show/hide navigation and admin features.
 */
export const getApiAuthCapabilitiesOptions = (options?: Options<GetApiAuthCapabilitiesData>) => queryOptions<GetApiAuthCapabilitiesResponse, DefaultError, GetApiAuthCapabilitiesResponse, ReturnType<typeof getApiAuthCapabilitiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiAuthCapabilities({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiAuthCapabilitiesQueryKey(options)
});

export const getApiServicesChatSessionsQueryKey = (options?: Options<GetApiServicesChatSessionsData>) => createQueryKey('getApiServicesChatSessions', options, false, ['chatSessions']);

/**
 * List chat sessions
 */
export const getApiServicesChatSessionsOptions = (options?: Options<GetApiServicesChatSessionsData>) => queryOptions<GetApiServicesChatSessionsResponse, GetApiServicesChatSessionsError, GetApiServicesChatSessionsResponse, ReturnType<typeof getApiServicesChatSessionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiServicesChatSessions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiServicesChatSessionsQueryKey(options)
});

export const getApiServicesChatSessionsInfiniteQueryKey = (options?: Options<GetApiServicesChatSessionsData>): QueryKey<Options<GetApiServicesChatSessionsData>> => createQueryKey('getApiServicesChatSessions', options, true);

/**
 * List chat sessions
 */
export const getApiServicesChatSessionsInfiniteOptions = (options?: Options<GetApiServicesChatSessionsData>) => infiniteQueryOptions<GetApiServicesChatSessionsResponse, GetApiServicesChatSessionsError, InfiniteData<GetApiServicesChatSessionsResponse>, QueryKey<Options<GetApiServicesChatSessionsData>>, number | Pick<QueryKey<Options<GetApiServicesChatSessionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiServicesChatSessionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getApiServicesChatSessions({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiServicesChatSessionsInfiniteQueryKey(options)
});

/**
 * Create chat session
 */
export const postApiServicesChatSessionsMutation = (options?: Partial<Options<PostApiServicesChatSessionsData>>): UseMutationOptions<PostApiServicesChatSessionsResponse, PostApiServicesChatSessionsError, Options<PostApiServicesChatSessionsData>> => {
    const mutationOptions: UseMutationOptions<PostApiServicesChatSessionsResponse, PostApiServicesChatSessionsError, Options<PostApiServicesChatSessionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiServicesChatSessions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiServicesChatSessionsByIdQueryKey = (options: Options<GetApiServicesChatSessionsByIdData>) => createQueryKey('getApiServicesChatSessionsById', options, false, ['chatSessions']);

/**
 * Get chat session with messages
 */
export const getApiServicesChatSessionsByIdOptions = (options: Options<GetApiServicesChatSessionsByIdData>) => queryOptions<GetApiServicesChatSessionsByIdResponse, GetApiServicesChatSessionsByIdError, GetApiServicesChatSessionsByIdResponse, ReturnType<typeof getApiServicesChatSessionsByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiServicesChatSessionsById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiServicesChatSessionsByIdQueryKey(options)
});

/**
 * Update chat session
 */
export const patchApiServicesChatSessionsByIdMutation = (options?: Partial<Options<PatchApiServicesChatSessionsByIdData>>): UseMutationOptions<PatchApiServicesChatSessionsByIdResponse, PatchApiServicesChatSessionsByIdError, Options<PatchApiServicesChatSessionsByIdData>> => {
    const mutationOptions: UseMutationOptions<PatchApiServicesChatSessionsByIdResponse, PatchApiServicesChatSessionsByIdError, Options<PatchApiServicesChatSessionsByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchApiServicesChatSessionsById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Archive chat session
 */
export const postApiServicesChatSessionsByIdArchiveMutation = (options?: Partial<Options<PostApiServicesChatSessionsByIdArchiveData>>): UseMutationOptions<PostApiServicesChatSessionsByIdArchiveResponse, PostApiServicesChatSessionsByIdArchiveError, Options<PostApiServicesChatSessionsByIdArchiveData>> => {
    const mutationOptions: UseMutationOptions<PostApiServicesChatSessionsByIdArchiveResponse, PostApiServicesChatSessionsByIdArchiveError, Options<PostApiServicesChatSessionsByIdArchiveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiServicesChatSessionsByIdArchive({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unarchive chat session
 */
export const postApiServicesChatSessionsByIdUnarchiveMutation = (options?: Partial<Options<PostApiServicesChatSessionsByIdUnarchiveData>>): UseMutationOptions<PostApiServicesChatSessionsByIdUnarchiveResponse, PostApiServicesChatSessionsByIdUnarchiveError, Options<PostApiServicesChatSessionsByIdUnarchiveData>> => {
    const mutationOptions: UseMutationOptions<PostApiServicesChatSessionsByIdUnarchiveResponse, PostApiServicesChatSessionsByIdUnarchiveError, Options<PostApiServicesChatSessionsByIdUnarchiveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiServicesChatSessionsByIdUnarchive({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete collection
 */
export const deleteApiServicesAssistantcollectionsByIdMutation = (options?: Partial<Options<DeleteApiServicesAssistantcollectionsByIdData>>): UseMutationOptions<DeleteApiServicesAssistantcollectionsByIdResponse, DeleteApiServicesAssistantcollectionsByIdError, Options<DeleteApiServicesAssistantcollectionsByIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiServicesAssistantcollectionsByIdResponse, DeleteApiServicesAssistantcollectionsByIdError, Options<DeleteApiServicesAssistantcollectionsByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiServicesAssistantcollectionsById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiServicesAssistantcollectionsByIdQueryKey = (options: Options<GetApiServicesAssistantcollectionsByIdData>) => createQueryKey('getApiServicesAssistantcollectionsById', options, false, ['collections']);

/**
 * Get collection by ID
 */
export const getApiServicesAssistantcollectionsByIdOptions = (options: Options<GetApiServicesAssistantcollectionsByIdData>) => queryOptions<GetApiServicesAssistantcollectionsByIdResponse, GetApiServicesAssistantcollectionsByIdError, GetApiServicesAssistantcollectionsByIdResponse, ReturnType<typeof getApiServicesAssistantcollectionsByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiServicesAssistantcollectionsById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiServicesAssistantcollectionsByIdQueryKey(options)
});

/**
 * Update collection
 */
export const patchApiServicesAssistantcollectionsByIdMutation = (options?: Partial<Options<PatchApiServicesAssistantcollectionsByIdData>>): UseMutationOptions<PatchApiServicesAssistantcollectionsByIdResponse, PatchApiServicesAssistantcollectionsByIdError, Options<PatchApiServicesAssistantcollectionsByIdData>> => {
    const mutationOptions: UseMutationOptions<PatchApiServicesAssistantcollectionsByIdResponse, PatchApiServicesAssistantcollectionsByIdError, Options<PatchApiServicesAssistantcollectionsByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchApiServicesAssistantcollectionsById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiServicesAssistantcollectionsQueryKey = (options?: Options<GetApiServicesAssistantcollectionsData>) => createQueryKey('getApiServicesAssistantcollections', options, false, ['collections']);

/**
 * List collections with pagination
 */
export const getApiServicesAssistantcollectionsOptions = (options?: Options<GetApiServicesAssistantcollectionsData>) => queryOptions<GetApiServicesAssistantcollectionsResponse, GetApiServicesAssistantcollectionsError, GetApiServicesAssistantcollectionsResponse, ReturnType<typeof getApiServicesAssistantcollectionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiServicesAssistantcollections({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiServicesAssistantcollectionsQueryKey(options)
});

export const getApiServicesAssistantcollectionsInfiniteQueryKey = (options?: Options<GetApiServicesAssistantcollectionsData>): QueryKey<Options<GetApiServicesAssistantcollectionsData>> => createQueryKey('getApiServicesAssistantcollections', options, true);

/**
 * List collections with pagination
 */
export const getApiServicesAssistantcollectionsInfiniteOptions = (options?: Options<GetApiServicesAssistantcollectionsData>) => infiniteQueryOptions<GetApiServicesAssistantcollectionsResponse, GetApiServicesAssistantcollectionsError, InfiniteData<GetApiServicesAssistantcollectionsResponse>, QueryKey<Options<GetApiServicesAssistantcollectionsData>>, number | Pick<QueryKey<Options<GetApiServicesAssistantcollectionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiServicesAssistantcollectionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getApiServicesAssistantcollections({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiServicesAssistantcollectionsInfiniteQueryKey(options)
});

/**
 * Create collection
 */
export const postApiServicesAssistantcollectionsMutation = (options?: Partial<Options<PostApiServicesAssistantcollectionsData>>): UseMutationOptions<PostApiServicesAssistantcollectionsResponse, PostApiServicesAssistantcollectionsError, Options<PostApiServicesAssistantcollectionsData>> => {
    const mutationOptions: UseMutationOptions<PostApiServicesAssistantcollectionsResponse, PostApiServicesAssistantcollectionsError, Options<PostApiServicesAssistantcollectionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiServicesAssistantcollections({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiServicesAssistantcollectionsByIdAssistantsQueryKey = (options: Options<GetApiServicesAssistantcollectionsByIdAssistantsData>) => createQueryKey('getApiServicesAssistantcollectionsByIdAssistants', options, false, ['collections']);

/**
 * List assistants in collection
 */
export const getApiServicesAssistantcollectionsByIdAssistantsOptions = (options: Options<GetApiServicesAssistantcollectionsByIdAssistantsData>) => queryOptions<GetApiServicesAssistantcollectionsByIdAssistantsResponse, GetApiServicesAssistantcollectionsByIdAssistantsError, GetApiServicesAssistantcollectionsByIdAssistantsResponse, ReturnType<typeof getApiServicesAssistantcollectionsByIdAssistantsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiServicesAssistantcollectionsByIdAssistants({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiServicesAssistantcollectionsByIdAssistantsQueryKey(options)
});

export const getApiServicesAssistantcollectionsByIdAssistantsInfiniteQueryKey = (options: Options<GetApiServicesAssistantcollectionsByIdAssistantsData>): QueryKey<Options<GetApiServicesAssistantcollectionsByIdAssistantsData>> => createQueryKey('getApiServicesAssistantcollectionsByIdAssistants', options, true);

/**
 * List assistants in collection
 */
export const getApiServicesAssistantcollectionsByIdAssistantsInfiniteOptions = (options: Options<GetApiServicesAssistantcollectionsByIdAssistantsData>) => infiniteQueryOptions<GetApiServicesAssistantcollectionsByIdAssistantsResponse, GetApiServicesAssistantcollectionsByIdAssistantsError, InfiniteData<GetApiServicesAssistantcollectionsByIdAssistantsResponse>, QueryKey<Options<GetApiServicesAssistantcollectionsByIdAssistantsData>>, number | Pick<QueryKey<Options<GetApiServicesAssistantcollectionsByIdAssistantsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiServicesAssistantcollectionsByIdAssistantsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getApiServicesAssistantcollectionsByIdAssistants({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiServicesAssistantcollectionsByIdAssistantsInfiniteQueryKey(options)
});

/**
 * Add assistants to collection
 */
export const postApiServicesAssistantcollectionsByIdAssistantsMutation = (options?: Partial<Options<PostApiServicesAssistantcollectionsByIdAssistantsData>>): UseMutationOptions<PostApiServicesAssistantcollectionsByIdAssistantsResponse, PostApiServicesAssistantcollectionsByIdAssistantsError, Options<PostApiServicesAssistantcollectionsByIdAssistantsData>> => {
    const mutationOptions: UseMutationOptions<PostApiServicesAssistantcollectionsByIdAssistantsResponse, PostApiServicesAssistantcollectionsByIdAssistantsError, Options<PostApiServicesAssistantcollectionsByIdAssistantsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiServicesAssistantcollectionsByIdAssistants({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove assistant from collection
 */
export const deleteApiServicesAssistantcollectionsByIdAssistantsByAssistantIdMutation = (options?: Partial<Options<DeleteApiServicesAssistantcollectionsByIdAssistantsByAssistantIdData>>): UseMutationOptions<DeleteApiServicesAssistantcollectionsByIdAssistantsByAssistantIdResponse, DeleteApiServicesAssistantcollectionsByIdAssistantsByAssistantIdError, Options<DeleteApiServicesAssistantcollectionsByIdAssistantsByAssistantIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiServicesAssistantcollectionsByIdAssistantsByAssistantIdResponse, DeleteApiServicesAssistantcollectionsByIdAssistantsByAssistantIdError, Options<DeleteApiServicesAssistantcollectionsByIdAssistantsByAssistantIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiServicesAssistantcollectionsByIdAssistantsByAssistantId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unfollow a collection
 */
export const deleteApiServicesAssistantcollectionsByIdFollowMutation = (options?: Partial<Options<DeleteApiServicesAssistantcollectionsByIdFollowData>>): UseMutationOptions<DeleteApiServicesAssistantcollectionsByIdFollowResponse, DeleteApiServicesAssistantcollectionsByIdFollowError, Options<DeleteApiServicesAssistantcollectionsByIdFollowData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiServicesAssistantcollectionsByIdFollowResponse, DeleteApiServicesAssistantcollectionsByIdFollowError, Options<DeleteApiServicesAssistantcollectionsByIdFollowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiServicesAssistantcollectionsByIdFollow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Follow a collection
 */
export const postApiServicesAssistantcollectionsByIdFollowMutation = (options?: Partial<Options<PostApiServicesAssistantcollectionsByIdFollowData>>): UseMutationOptions<PostApiServicesAssistantcollectionsByIdFollowResponse, PostApiServicesAssistantcollectionsByIdFollowError, Options<PostApiServicesAssistantcollectionsByIdFollowData>> => {
    const mutationOptions: UseMutationOptions<PostApiServicesAssistantcollectionsByIdFollowResponse, PostApiServicesAssistantcollectionsByIdFollowError, Options<PostApiServicesAssistantcollectionsByIdFollowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiServicesAssistantcollectionsByIdFollow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete an assistant kind
 */
export const deleteApiServicesAssistantkindsByIdMutation = (options?: Partial<Options<DeleteApiServicesAssistantkindsByIdData>>): UseMutationOptions<DeleteApiServicesAssistantkindsByIdResponse, DeleteApiServicesAssistantkindsByIdError, Options<DeleteApiServicesAssistantkindsByIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteApiServicesAssistantkindsByIdResponse, DeleteApiServicesAssistantkindsByIdError, Options<DeleteApiServicesAssistantkindsByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteApiServicesAssistantkindsById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiServicesAssistantkindsByIdQueryKey = (options: Options<GetApiServicesAssistantkindsByIdData>) => createQueryKey('getApiServicesAssistantkindsById', options, false, ['kinds']);

/**
 * Get assistant kind by ID
 */
export const getApiServicesAssistantkindsByIdOptions = (options: Options<GetApiServicesAssistantkindsByIdData>) => queryOptions<GetApiServicesAssistantkindsByIdResponse, GetApiServicesAssistantkindsByIdError, GetApiServicesAssistantkindsByIdResponse, ReturnType<typeof getApiServicesAssistantkindsByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiServicesAssistantkindsById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiServicesAssistantkindsByIdQueryKey(options)
});

/**
 * Update an assistant kind
 */
export const patchApiServicesAssistantkindsByIdMutation = (options?: Partial<Options<PatchApiServicesAssistantkindsByIdData>>): UseMutationOptions<PatchApiServicesAssistantkindsByIdResponse, PatchApiServicesAssistantkindsByIdError, Options<PatchApiServicesAssistantkindsByIdData>> => {
    const mutationOptions: UseMutationOptions<PatchApiServicesAssistantkindsByIdResponse, PatchApiServicesAssistantkindsByIdError, Options<PatchApiServicesAssistantkindsByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchApiServicesAssistantkindsById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiServicesAssistantkindsQueryKey = (options?: Options<GetApiServicesAssistantkindsData>) => createQueryKey('getApiServicesAssistantkinds', options, false, ['kinds']);

/**
 * List all assistant kinds
 */
export const getApiServicesAssistantkindsOptions = (options?: Options<GetApiServicesAssistantkindsData>) => queryOptions<GetApiServicesAssistantkindsResponse, DefaultError, GetApiServicesAssistantkindsResponse, ReturnType<typeof getApiServicesAssistantkindsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiServicesAssistantkinds({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiServicesAssistantkindsQueryKey(options)
});

/**
 * Create a new assistant kind
 */
export const postApiServicesAssistantkindsMutation = (options?: Partial<Options<PostApiServicesAssistantkindsData>>): UseMutationOptions<PostApiServicesAssistantkindsResponse, PostApiServicesAssistantkindsError, Options<PostApiServicesAssistantkindsData>> => {
    const mutationOptions: UseMutationOptions<PostApiServicesAssistantkindsResponse, PostApiServicesAssistantkindsError, Options<PostApiServicesAssistantkindsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiServicesAssistantkinds({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
